import { render, staticRenderFns } from "./mediaInfo.vue?vue&type=template&id=6b85c13e&scoped=true"
import script from "./mediaInfo.vue?vue&type=script&lang=js"
export * from "./mediaInfo.vue?vue&type=script&lang=js"
import style0 from "./mediaInfo.vue?vue&type=style&index=0&id=6b85c13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b85c13e",
  null
  
)

export default component.exports